export default __webpack_public_path__ + "static/media/shellfish.7b36b6fa.svg";